import PropTypes from "prop-types";
import { unescape } from "lodash";

import styles from "./showFields.module.css";
import { previewHtml } from "../../helpers/cellPreview";

function Html({ value, options = {} }) {
  // Table layout: strip markup and show a compact plain-text preview.
  if (options.truncate) {
    return <div className={styles.Html}>{previewHtml(unescape(value))}</div>;
  }
  return (
    <div
      className={styles.Html}
      dangerouslySetInnerHTML={{
        __html: unescape(value),
      }}
    />
  );
}

Html.propTypes = {
  value: PropTypes.string,
  options: PropTypes.shape({ truncate: PropTypes.bool }),
};

export default Html;
